"use client";

import * as X from "@/ui";

import ZapptaxIcon from "@/assets/shared-zapptax-icon-black.svg";
import SavingsImage from "@/assets/traveler-home-calculator-savings.svg";
import MobileImage from "@/assets/traveler-home-calculator-mobile.svg";

import {
  useCalculator,
  NonLinearSlider,
  PriceInput,

  CountryVat,
  type Country,
} from "./calculator";
import { useCalculatorComponent } from "@/providers/strapi/content/types/singleTypes/calculator";
import ReactMarkdown from "react-markdown";



// const data = {
//   calculator: {
//     countryFieldLabel: {
//       en: "Where will you be shopping?",
//       fr: `Dans quel pays allez-vous faire vos achats${X.Nbsp}?`,
//       zh: ""
//     },

//     amountFieldLabel: {
//       en: "How much are you planning to spend?",
//       fr: `Quel montant comptez-vous dépenser${X.Nbsp}?`,
//       zh: ""
//     },

//     countryLabel: {
//       "FR": { en: "France", fr: "France", zh: "", ko: "" },
//       "ES": { en: "Spain", fr: "Espagne", zh: "", ko: "" },
//       "BE": { en: "Belgium", fr: "Belgique", zh: "", ko: "" },
//     } satisfies { [k in Country]: X.Localization<string> },

//     vatAmountLabel: (vatAmount: string) => ({
//       en: <>A VAT of <strong>€{vatAmount}</strong></>,
//       fr: <>Soit une TVA de <strong>€{vatAmount}</strong></>,
//       zh: <></>
//     }),

//     outputYourRefund: {
//       en: "Your refund with Zapptax",
//       fr: "Votre remboursement via Zapptax",
//       zh: ""
//     },

//     outputOfTheVat: {
//       en: "of the VAT",
//       fr: "de la TVA",
//       zh: ""
//     },

//     aboutRates: {
//       en: [
//         "Our refund rates are progressive: the more you spend, the higher the refund.",
//         "We combine all your purchases by country to apply the best possible refund rate.",

//       ],
//       fr: [
//         `Nos taux de remboursement sont progressifs${X.Nbsp}: plus vous dépensez, plus nous vous remboursons.`,
//         `Nous regroupons tous vos achats par pays afin que vous bénéficiez du taux de remboursement le plus avantageux${X.Nbsp}!`,
//       ],
//       zh: []
//     },

//     legal: (country: Country) => ({
//       en: `*${X.Nbsp}This is an estimate based on a ${CountryVat[country]}% VAT rate in ${data.calculator.countryLabel[country].en}. Your exact refund will depend on the VAT applied to each item.`,
//       fr: `*${X.Nbsp}Ce montant est une estimation basée sur un taux de TVA de ${CountryVat[country]}% en ${data.calculator.countryLabel[country].fr}. Votre remboursement exact sera calculé en fonction du taux de TVA appliqué à chaque produit.`,
//       zh: ""
//     }),
//   },
// };


export function CalculatorSection(props: X.PageProps<{
  onOpenMobileCalculator: () => void;
}>) {
  // const tr = X.useTranslator();
  const title = useCalculatorComponent('title')
  return (
    <section id="calculator" className="my-10 xl:my-20 scroll-mt-[120px]">
      <div className={X.clsx(X.desktopOnly("block"))}>
        <div className="max-w-content mx-auto border border-black rounded-3xl p-10 pb-6 relative">
          <X.Image
            src={ZapptaxIcon}
            alt="Save with Zapptax"
            className="w-12 h-auto absolute top-10 right-10"
          />

          {/* <h2 className="text-[48px] mb-10 leading-tight [&_strong]:font-semibold">
            {tr({
              en: <><strong>Maximize your travel budget</strong><br />Calculate your savings here</>,
              fr: <><strong>Combien allez-vous économiser</strong><br />sur vos prochains achats{X.Nbsp}?</>,
            })}
          </h2> */}
          <ReactMarkdown
            components={{
              p: ({ ...props }) => <h2 {...props} className="text-[48px] mb-10 leading-tight [&_strong]:font-semibold" />
            }}>
            {title}
          </ReactMarkdown>
          <DesktopCalculator locale={props.locale} />
        </div>
      </div>

      <MobilePlaceholder
        locale={props.locale}
        openCalculator={props.onOpenMobileCalculator}
      />
    </section>
  );
}


export function MobileCalculatorModal(props: X.PageProps<{
  isOpen: boolean;
  onClose: () => void;
}>) {
  return (
    <X.Modal
      onClose={props.onClose}
      className={X.clsx(
        X.mobileOnly(),
        "fixed inset-0 bg-white flex flex-col",
      )}>
      {props.isOpen && (
        <>
          <div className="flex flex-row items-center justify-start">
            <div className="w-[80px] h-[80px] flex justify-center flex-row items-center" onClick={props.onClose}>
              <X.Icon.ArrowLeft onClick={props.onClose} size={24} />
            </div>
          </div>
          <div className="flex-auto mb-4 overflow-x-hidden overflow-y-auto [-ms-overflow-style:none] [scrollbar-width:none]">
            <MobileCalculator locale={props.locale} />
          </div>
        </>
      )}
    </X.Modal>
  );
}


export function MobilePlaceholder(props: X.PageProps<{
  openCalculator: () => void;
}>) {
  // const tr = X.useTranslator();
  const title = useCalculatorComponent('title');
  const mobileCta = useCalculatorComponent('mobileCta');

  return (
    <div className={X.clsx(
      X.mobileOnly(),
      "px-mobile-margin py-5 bg-yellow",
      "flex flex-row gap-8 items-center",
    )}>
      <div className="flex-auto">
        <X.Image src={MobileImage} alt="Mobile" className="w-[180px] h-auto scale-170 md:scale-120" />
      </div>
      <div className="flex-auto">
        {/* <p className="text-[20px] mb-4">
          {tr({
            en: <><strong className="font-semibold">How much can you save</strong> on your purchases?</>,
            fr: <><strong className="font-semibold">Combien allez-vous économiser</strong> sur vos prochains achats ? </>,
          })}
        </p> */}
        <ReactMarkdown components={{
          p: ({ ...props }) => <p {...props} className="text-[20px] mb-4" />,
          strong: ({ ...props }) => <strong {...props} className="font-semibold" />
        }}>
          {title}
        </ReactMarkdown>

        <X.Button
          tertiary
          onClick={props.openCalculator}
          label={mobileCta}
        // label={tr({
        //   en: "Check out now",
        //   fr: "Calculez par vous-même",
        // })}
        />
      </div>
    </div>
  );
}


export function MobileCalculator(props: X.PageProps<{
  noTitle?: boolean;
}>) {
  // const tr = X.useTranslator();

  const {
    country, setCountry,
    grossAmount, setGrossAmount,
    setValidValue,

    sliderValue,
    vatAmount,
    refundableAmount,
    refundablePercentOfVat,
  } = useCalculator();

  const labelStyle = "mb-3 text-[16px] font-semibold";
  const mobileTitle = useCalculatorComponent('mobileTitle');
  const countryTabLabel = useCalculatorComponent('countryTabLabel');
  const amountInputLabel = useCalculatorComponent('amountInputLabel');
  const inputHint = useCalculatorComponent('inputHint');
  const resultCardTitle = useCalculatorComponent('resultCardTitle');
  const resultCardHint = useCalculatorComponent('resultCardHint');
  const info1 = useCalculatorComponent('info1');
  const info2 = useCalculatorComponent('info2');
  const disclaimer = useCalculatorComponent('disclaimer');

  const FR = useCalculatorComponent('france');
  const BE = useCalculatorComponent('belgium');
  const ES = useCalculatorComponent('spain');
  const countries = {
    FR, ES, BE
  }
  return (
    <div className="flex flex-col gap-3 -translate-y-1">
      {props.noTitle !== true && (
        // <h1 className="text-[30px] leading-tight font-bold text-center mx-mobile-margin">{tr({
        //   en: "Let's go!",
        //   fr: `C'est parti${X.Nbsp}!`,
        //   zh: ""
        // })}</h1>
        <ReactMarkdown components={{
          p: ({ ...props }) => <h1 {...props} className="text-[30px] leading-tight font-bold text-center mx-mobile-margin" />
        }}>
          {mobileTitle}
        </ReactMarkdown>
      )}

      <div className="mx-mobile-margin-half">
        {/* <p className={X.clsx(labelStyle)}>
          {tr(data.calculator.countryFieldLabel)}
          {countryTabLabel}
        </p> */}
        <ReactMarkdown
          components={{
            p: ({ ...props }) => <p {...props} className={X.clsx(labelStyle)} />
          }}>
          {countryTabLabel}
        </ReactMarkdown>

        <div className="flex flex-row flex-nowrap justify-between gap-2 mb-4">
          <X.Button

            primary={country === 'FR'}
            tertiary={country !== 'FR'}
            onClick={() => setCountry('FR')}
            label={FR}
            className={X.clsx(
              "!h-[48px] !px-6 !text-[14px]",
              country === "FR" && "font-semibold",
              country === 'FR' ? "opacity-100" : "opacity-70",
            )}
          />
          <X.Button

            primary={country === 'BE'}
            tertiary={country !== 'BE'}
            onClick={() => setCountry('BE')}
            label={BE}
            className={X.clsx(
              "!h-[48px] !px-6 !text-[14px]",
              country === "BE" && "font-semibold",
              country === 'BE' ? "opacity-100" : "opacity-70",
            )}
          />

          <X.Button

            primary={country === 'ES'}
            tertiary={country !== 'ES'}
            onClick={() => setCountry('ES')}
            label={ES}
            className={X.clsx(
              "!h-[48px] !px-6 !text-[14px]",
              country === "ES" && "font-semibold",
              country === 'ES' ? "opacity-100" : "opacity-70",
            )}
          />
          {/* {(Object.keys(CountryVat) as Country[]).map(loopCountry => (
            <X.Button
              key={loopCountry}
              primary={country === loopCountry}
              tertiary={country !== loopCountry}
              onClick={() => setCountry(loopCountry)}
              label={tr(data.calculator.countryLabel[loopCountry])}
              className={X.clsx(
                "!h-[48px] !px-6 !text-[14px]",
                country === loopCountry && "font-semibold",
                country === loopCountry ? "opacity-100" : "opacity-70",
              )}
            />
          ))} */}
        </div>
      </div>

      <div className="flex flex-col">
        {/* <p className={X.clsx(labelStyle, "mx-mobile-margin-half")}>
          {tr(data.calculator.amountFieldLabel)}
          {amountInputLabel}
        </p> */}
        <ReactMarkdown components={{
          p: ({ ...props }) => <p {...props} className={X.clsx(labelStyle, "mx-mobile-margin-half")} />
        }}>
          {amountInputLabel}
        </ReactMarkdown>
        <div className="border border-gray-300 rounded flex-grow flex flex-row relative mb-4 h-[47px] mx-mobile-margin-half">
          <PriceInput
            locale={props.locale}
            className="px-4 pl-8 py-1 w-full text-[20px] font-semibold flex-grow"
            onValidChange={setValidValue}
            onChange={setGrossAmount}
            value={grossAmount}
          />
          <div className="absolute left-3 top-0 bottom-0 flex flex-row items-center text-[18px] font-light">€</div>
        </div>
        <div className="px-mobile-margin-half">
          <NonLinearSlider
            value={sliderValue}
            onChange={setGrossAmount}
          />
        </div>
        <span className="text-sm bg-surface-gray mt-4 rounded-md px-4 h-[47px] leading-[47px] text-[14px] font-light [&_strong]:font-semibold [&_strong]:text-[16px] mx-mobile-margin-half">
          {/* {tr(data.calculator.vatAmountLabel(vatAmount))} */}
          {inputHint} <strong>€{vatAmount}</strong>
        </span>

        <div className="mx-mobile-margin-half">
          <div className="bg-yellow p-4 rounded-xl text-black my-6 w-full relative">
            <div className="text-[20px] font-semibold leading-tight">
              {/* {tr(data.calculator.outputYourRefund)} */}
              <ReactMarkdown>
                {resultCardTitle}
              </ReactMarkdown>
            </div>
            <div className="text-[44px] font-semibold leading-tight mb-4">€{refundableAmount}</div>
            <div className="flex flex-row items-end gap-1 justify-end">
              <div className="text-[30px] leading-[30px] font-semibold">
                ={(refundablePercentOfVat)}%
              </div>
              <div className="text-[16px] leading-[19px] font-medium">
                {/* {tr(data.calculator.outputOfTheVat)} */}
                <ReactMarkdown>
                  {resultCardHint}
                </ReactMarkdown>
              </div>
            </div>
            <X.Image
              src={ZapptaxIcon}
              alt="Save with Zapptax"
              className="w-8 h-auto absolute top-4 right-4"
            />
          </div>
        </div>

        <div className="flex flex-row mb-6 mt-2 gap-2 mx-mobile-margin-half">
          <X.Image src={SavingsImage} alt="Economy" className="h-[50px] w-auto" />
          <div className="flex flex-col gap-2 leading-tight">
            <ReactMarkdown components={{
              p: ({ ...props }) => <p {...props} className="text-[14px] font-medium" />
            }}>
              {info1}
            </ReactMarkdown>
            <ReactMarkdown components={{
              p: ({ ...props }) => <p {...props} className="text-[14px] font-medium" />
            }}>
              {info2}
            </ReactMarkdown>
            {/* <p className="text-[18px] font-medium">{info1}</p>
            <p className="text-[18px] font-medium">{info2}</p> */}
            {/* {tr(data.calculator.aboutRates).map((text, i) => (
              <p key={i} className="text-[14px] font-semibold">{text}</p>
            ))} */}
          </div>
        </div>

        {/* <p className="text-[10px] mb-2 px-mobile-margin-half">
          {tr(data.calculator.legal(country))}
          {disclaimer}
        </p> */}
        <ReactMarkdown components={{
          p: ({ ...props }) => <p {...props} className="text-[10px] mb-2 px-mobile-margin-half" />
        }}>
          {disclaimer.replace("${VAT}", country === 'FR' ? '20' : '21').replace("${COUNTRY}", countries[country])}
        </ReactMarkdown>
      </div>
    </div>
  );
}


export function DesktopCalculator(props: X.PageProps) {
  // const tr = X.useTranslator();

  const {
    country, setCountry,
    grossAmount, setGrossAmount,
    setValidValue,

    sliderValue,
    vatAmount,
    refundableAmount,
    refundablePercentOfVat,
  } = useCalculator();

  const countryTabLabel = useCalculatorComponent('countryTabLabel');
  const FR = useCalculatorComponent('france');
  const ES = useCalculatorComponent('spain');
  const BE = useCalculatorComponent('belgium');
  const amountInputLabel = useCalculatorComponent('amountInputLabel');
  const inputHint = useCalculatorComponent('inputHint');
  const resultCardTitle = useCalculatorComponent('resultCardTitle');
  const resultCardHint = useCalculatorComponent('resultCardHint');
  const info1 = useCalculatorComponent('info1');
  const info2 = useCalculatorComponent('info2');
  const disclaimer = useCalculatorComponent('disclaimer');
  const countries = {
    FR, ES, BE
  }
  return (
    <div>
      <div className="flex flex-row gap-22">
        <div className="flex-grow">
          <div className="mb-12">
            {/* <p className="mb-4 text-[20px] font-semibold">
              {tr(data.calculator.countryFieldLabel)}
              {countryTabLabel}
            </p> */}
            <ReactMarkdown
              components={{
                p: ({ ...props }) => <p {...props} className="mb-4 text-[20px] font-semibold" />
              }}>
              {countryTabLabel}
            </ReactMarkdown>
            <div className="flex gap-4 justify-between">
              {(Object.keys(CountryVat) as Country[]).map(loopCountry => (
                <X.Button
                  key={loopCountry}
                  primary={country === loopCountry}
                  tertiary={country !== loopCountry}
                  onClick={() => setCountry(loopCountry)}
                  // label={tr(data.calculator.countryLabel[loopCountry])}
                  label={countries[loopCountry]}
                  className={X.clsx(
                    "py-[14px] !h-[58px] !px-10 !text-[16px]",
                    country === loopCountry ? "!font-semibold" : "!font-normal",
                    country === loopCountry ? "opacity-100" : "opacity-70 hover:opacity-100",
                  )}
                />
              ))}
            </div>
          </div>

          <div className="mb-8">
            {/* <p className="mb-4 text-[20px] font-semibold">
              {tr(data.calculator.amountFieldLabel)}
              {amountInputLabel}
            </p> */}
            <ReactMarkdown components={{
              p: ({ ...props }) => <p {...props} className="mb-4 text-[20px] font-semibold" />
            }}>
              {amountInputLabel}
            </ReactMarkdown>
            <div className="flex items-center gap-3 mb-4 xl:mb-6">
              <div className="border border-gray-300 rounded flex-grow flex flex-row relative h-[52px] leading-[52px] px-1">
                <PriceInput
                  locale={props.locale}
                  className="px-4 pl-8 py-2 w-40 text-[20px] font-semibold flex-grow"
                  onValidChange={setValidValue}
                  onChange={setGrossAmount}
                  value={grossAmount}
                />
                <div className="absolute left-4 top-0 bottom-0 flex flex-row items-center text-[18px] leading-[52px] font-light">€</div>
              </div>
              <span className="bg-surface-gray py-4 rounded-md px-4 w-[220px] text-[14px] font-light [&_strong]:font-semibold [&_strong]:text-[16px] h-[52px]">
                {/* {tr(data.calculator.vatAmountLabel(vatAmount))} */}
                {inputHint} <strong>€{vatAmount}</strong>
              </span>
            </div>
            <NonLinearSlider
              value={sliderValue}
              onChange={setGrossAmount}
            />
          </div>
        </div>

        <div className="bg-yellow p-10 rounded-xl text-black mb-6 w-[520px] flex flex-col justify-between">
          <div>
            <div className="text-[24px] font-medium leading-tight mb-1">
              {/* {tr(data.calculator.outputYourRefund)} */}
              <ReactMarkdown>
                {resultCardTitle}
              </ReactMarkdown>
            </div>
            <div className="text-[76px] leading-tight">€{refundableAmount}</div>
          </div>
          <div>
            <div className="text-[34px] font-semibold leading-tight">
              ={refundablePercentOfVat}%
            </div>
            <div className="text-[18px] font-medium leading-tight">
              {/* {tr(data.calculator.outputOfTheVat)} */}
              <ReactMarkdown>
                {resultCardHint}
              </ReactMarkdown>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-row mb-8 mt-8 gap-4">
        <X.Image src={SavingsImage} alt="Economy" className="h-[50px] w-auto" />
        <div className="flex flex-col gap-0">
          {/* <p className="text-[18px] font-medium">{info1}</p>
          <p className="text-[18px] font-medium">{info2}</p> */}

          <ReactMarkdown components={{
            p: ({ ...props }) => <p {...props} className="text-[18px] font-medium" />
          }}>
            {info1}
          </ReactMarkdown>
          <ReactMarkdown components={{
            p: ({ ...props }) => <p {...props} className="text-[18px] font-medium" />
          }}>
            {info2}
          </ReactMarkdown>
          {/* {tr(data.calculator.aboutRates).map((text, i) => (
            <p key={i} className="text-[18px] font-medium">{text}</p>
          ))} */}
        </div>
      </div>

      {/* <p className="text-[13px] text-gray-600">
        {tr(data.calculator.legal(country))}
        {disclaimer}
      </p> */}
      <ReactMarkdown components={{
        p: ({ ...props }) => <p {...props} className="text-[13px] text-gray-600" />
      }}>
        {disclaimer.replace("${VAT}", country === 'FR' ? '20' : '21').replace("${COUNTRY}", countries[country])}
      </ReactMarkdown>
    </div>
  );
}
